/* shto-reviews: Okendo draws and runs the reviews. This only
   1. drops the comma Okendo prints after each answer ("Nice Design,"), since Figma shows them as separate chips,
   2. on desktop measures each review's left column and intensity bar, so the CSS can lift the bar into the grey box on the
      left as Figma draws it (Okendo prints it with the review text on the right), and
   3. tags Okendo's parts with data-shto names so the page check can measure them, and
   4. marks reviews whose text isn't cut off (data-shto-fits), so the CSS hides Read More on them (client, 2026-10-07).
   It runs again whenever Okendo redraws (sort, filters, Show More). It changes no behaviour. */
(function () {
  var root = document.querySelector('[data-shto-section="shto-reviews"]');
  if (!root) return;
  var widget = root.querySelector('[data-oke-widget]');
  if (!widget) return;

  var TAGS = {
    'summary': '.oke-w-header-content',
    'rating.average': '.oke-w-ratingAverageModule-rating-average',
    'rating.stars': '.oke-w-ratingAverageModule-rating-stars',
    'rating.count': '.oke-w-ratingAverageModule-count',
    'bars.row-5.label': '.oke-w-breakdownModule-distribution-label-number',
    'bars.row-5.bar': '.oke-w-breakdownModule-distribution-bar',
    'bars.row-5.count': '.oke-w-breakdownModule-distribution-count',
    'recommend': '.oke-w-recommendsModule',
    'recommend.value': '.oke-w-recommendsModule-value',
    'recommend.text': '.oke-w-recommendsModule-text',
    'intensity.title': '.oke-w-header .oke-attrBar-title-text',
    'intensity.bar': '.oke-w-header .oke-barDefault',
    'photos': '.oke-w-mediaStrip .oke-mediaStrip',
    'photo-1': '.oke-w-mediaStrip .oke-mediaStrip > li .oke-media',
    'filters': '.oke-w-reviews-filterToggle',
    'write-review': '.oke-w-writeReview',
    'sort': '.oke-sortSelect-sort',
    'list': '.oke-w-reviews-main',
    'review-1.avatar': '.oke-w-reviews-list-item .oke-w-reviewer-avatar',
    'review-1.name': '.oke-w-reviews-list-item .oke-w-reviewer-name',
    'review-1.title': '.oke-w-reviews-list-item .oke-reviewContent-title',
    'show-more': '.oke-showMore-button'
  };

  function tidy() {
    var chips = widget.querySelectorAll('.oke-w-selectAttr-item-value > span');
    for (var i = 0; i < chips.length; i++) {
      // Edit Okendo's own text node in place (never replace it), so Okendo's later redraws still find it.
      for (var n = chips[i].lastChild; n; n = n.previousSibling) {
        if (n.nodeType !== 3 || !n.nodeValue.trim()) continue;
        var clean = n.nodeValue.replace(/,(\s*)$/, '$1');
        if (clean !== n.nodeValue) n.nodeValue = clean;
        break;
      }
    }
    place();
    fits();
    Object.keys(TAGS).forEach(function (name) {
      var el = widget.querySelector(TAGS[name]);
      if (el && el.getAttribute('data-shto') !== name) el.setAttribute('data-shto', name);
    });
  }

  // Read More only where the text is really cut off: Okendo adds .oke-is-truncated, and the body must still overflow.
  function fits() {
    var boxes = widget.querySelectorAll('.oke-reviewContent');
    for (var i = 0; i < boxes.length; i++) {
      var body = boxes[i].querySelector('.oke-reviewContent-body');
      var fit = !body || body.scrollHeight <= body.clientHeight + 1;
      if (fit !== boxes[i].hasAttribute('data-shto-fits')) {
        if (fit) boxes[i].setAttribute('data-shto-fits', ''); else boxes[i].removeAttribute('data-shto-fits');
      }
    }
  }

  function px(el, name, value) {
    var v = value == null ? '' : Math.round(value * 100) / 100 + 'px';
    if (el.style.getPropertyValue(name) !== v) {
      if (v) el.style.setProperty(name, v); else el.style.removeProperty(name);
    }
  }
  function place() {
    var reviews = widget.querySelectorAll('.oke-w-review');
    for (var i = 0; i < reviews.length; i++) {
      var review = reviews[i];
      var side = review.querySelector('.oke-w-review-side');
      var attr = review.querySelector('.oke-w-review-attributes');
      if (!side || !attr || getComputedStyle(attr).position !== 'absolute') {
        px(review, '--shto-rv-attr-h', null); px(review, '--shto-rv-attr-top', null);
        continue;
      }
      var room = parseFloat(getComputedStyle(side).paddingBottom) || 0;
      var r = review.getBoundingClientRect(), sr = side.getBoundingClientRect();
      px(review, '--shto-rv-attr-h', attr.getBoundingClientRect().height);
      px(review, '--shto-rv-attr-top', sr.bottom - r.top - room);
    }
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; tidy(); });
  }
  tidy();
  new MutationObserver(soon).observe(widget, { childList: true, subtree: true, characterData: true });
  if (window.ResizeObserver) new ResizeObserver(soon).observe(widget);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(soon);
})();
